import React from 'react';
import {Route, Routes} from "react-router-dom";
import BookList from "./BookList";
import BookDetail from "./BookDetail";
import BookCreateEdit from "./BookCreateEdit";
import MyBookCodes from "./MyBookCodes";
import StudentBookCodesDetail from "./StudentBookCodesDetail";
import BookImportCodes from "./BookImportCodes";

function BookRouter() {
    return (
        <Routes>
            <Route index element={<BookList />} />
            <Route path=":id" element={<BookDetail />} />
            <Route path="new" element={<BookCreateEdit />} />
            <Route path=":id/edit" element={<BookCreateEdit />} />
            <Route path=":id/import-codes" element={<BookImportCodes />} />
            <Route path="my" element={<MyBookCodes />} />
            <Route path="students/:studentId" element={<StudentBookCodesDetail />} />
        </Routes>
    );
}

export default function Books() {
    return <BookRouter />;
}
